'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadr';
var iconName = 'user-bounty-hunter';
var width = 448;
var height = 512;
var aliases = [];
var unicode = 'e2bf';
var svgPathData = ['M24 512c13.4-.1 24-10.8 24-24 0-48.6 39.4-88 88-88l176 0c48.6 0 88 39.4 88 88 0 13.2 10.6 23.9 23.7 24L272 512c8.8 0 16-7.2 16-16l0-8c0-5-2.4-9.8-6.4-12.8l-48-36c-5.7-4.3-13.5-4.3-19.2 0l-48 36c-4 3-6.4 7.8-6.4 12.8l0 8c0 8.8 7.2 16 16 16L24 512zM125 120c13.6-42 52.9-72 99-72s85.4 30 99 72L125 120z', 'M80 0C71.2 0 64 7.2 64 16l0 240c0 3.7 .6 7.3 1.6 10.7 3 15.6 15.2 28.3 31.4 31.6l100.8 20.2c5.2 1 10.4 1.6 15.7 1.6l20.9 0c5.3 0 10.5-.5 15.7-1.6L351 298.3c19.7-3.9 33.4-21.8 32.1-41.8l-7.4-114.3C370.5 62.2 304.1 0 224 0 170.5 0 123.1 27.7 96 70l0-38c8.8 0 16-7.2 16-16S104.8 0 96 0L80 0zm45 120c13.6-42 52.9-72 99-72s85.4 30 99 72L125 120zm-5.5 36.4l80.5 15.1 0 98.4-8.6-1.7c-4.3-44.6-33.1-82-72.8-98.8l.8-13zM256.6 268.2l-8.6 1.7 0-98.4 80.5-15.1 .8 13c-39.6 16.8-68.4 54.2-72.8 98.8zM136 400l176 0c48.6 0 88 39.4 88 88 0 13.3 10.7 24 24 24s24-10.7 24-24c0-75.1-60.9-136-136-136l-176 0c-75.1 0-136 60.9-136 136 0 13.3 10.7 24 24 24s24-10.7 24-24c0-48.6 39.4-88 88-88zm30.4 75.2c-4 3-6.4 7.8-6.4 12.8l0 8c0 8.8 7.2 16 16 16l96 0c8.8 0 16-7.2 16-16l0-8c0-5-2.4-9.8-6.4-12.8l-48-36c-5.7-4.3-13.5-4.3-19.2 0l-48 36z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faUserBountyHunter = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;